import { HttpEvent, HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';
import { some } from '@sapphire/result';

import { AuthActionsFacade, AuthSelectorsFacade } from '@ps/auth-data-access';

import { AccessTokenProvider } from './domain/access-token-provider';
import { RequestClassifier } from './domain/request-classifier';
import { Router } from '@angular/router';

export function authInterceptor(
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const router = inject(Router);
  const _authSelectorsFacade = inject(AuthSelectorsFacade);
  const _authActionsFacade = inject(AuthActionsFacade);

  const request = new RequestClassifier(req);
  if (request.isForPublicUrl()) {
    return next(req);
  }

  const userToken = _authSelectorsFacade
    .currentUser()
    .mapInto((user) => some(user.token))
    .unwrapOr(null);

  if (!userToken) {
    _authActionsFacade.logout();
    return next(req);
  }

  const token = new AccessTokenProvider().getAccessToken(
    req.url,
    router.url,
    userToken,
  );

  const headers: Record<string, string> = {
    //TODO Get the service user id in case it has the service operator access.
    'service-user-id': '',
    'access-token': token,
  };

  const clonedReq = req.clone({
    setHeaders: headers,
  });
  return next(clonedReq);
}
